export const isNear = (a: number, b: number, tolerance = 0.0000000000001): boolean => {
    return Math.abs(a - b) <= tolerance;
};
